import React from "react";
import cookie from "js-cookie";
import Welcome from "../component/sections/Welcome";
import NotFounded from "../component/partials/other/NotFounded";
import UnAuthorized from "../component/partials/other/UnAuthorized";
import actionCookie from "../helpers/action-cookie";
import sitesRoutes from "./sites";
import authRoutes from "./auth";
import userRoutes from "./user";
import pageRoutes from "./page";
import publisherRoutes from "./publisher";
import managePageRoutes from "./manage-page";
import managePublisherRoutes from "./manage-publisher";
import reportRoutes from "./report";
import positionRoutes from "./position";
import financeRoutes from "./finance";
import managePositionRoutes from "./manage-position";
import manageFinanceRoutes from "./manage-finance";
import supportRoutes from "./support";
import middleware from "./middleware/middleware";

const routes = [
  {
    path: "/",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <Welcome />,
        "Welcome"
      );
    },
    exact: true,
  },
  ...sitesRoutes,
  ...authRoutes,
  ...reportRoutes,
  ...userRoutes,
  ...publisherRoutes,
  ...managePublisherRoutes,
  ...pageRoutes,
  ...managePageRoutes,
  ...positionRoutes,
  ...managePositionRoutes,
  ...financeRoutes,
  ...manageFinanceRoutes,
  ...supportRoutes,
  {
    path: "/unauthorized",
    render: () =>
      middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <UnAuthorized />,
        "UnAuthorized"
      ),
    exact: true,
  },
  {
    path: "*",
    render: () =>
      middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <NotFounded />,
        "NotFounded"
      ),
    exact: true,
  },
];

routes.forEach((route) => {
  route.render = (function () {
    var cached_function = route.render;

    return function () {
      const result = cached_function.apply(this, arguments);
      cookie.set(
        actionCookie.PREVIOUS_PAGE_URL,
        cookie.get(actionCookie.CURRENT_PAGE_URL)
      );
      cookie.set(actionCookie.CURRENT_PAGE_URL, window.location.pathname);
      return result;
    };
  })();
});

export default routes;
